import { LocalesTree } from '@platform/front-types';

const startPage: LocalesTree = {
    title: 'Сбор и обработка заявок помощников',
    productDescription:
        'Здесь помощники и волонтеры подают заявку на включение в реестр. Наши администраторы обработают заявку в течение 3 дней',
    logoAlt: 'РКК logo',
};

export default startPage;
